/**
 * Gemeinsame Anzeige-Formatierung fuer eine Adresse mit Firma/Name/Straße/Zusatz/PLZ+Ort/Land
 * (Adressmodell, WARTESCHLANGE Punkt 7, PR4 § 5 Punkt 4 "Anzeige-Update"). Bisherige
 * Anzeige-Stellen (`event-detail.tsx#lieferadresseStructured`, die "Kundenadresse (Standard)"-
 * Hinweiszeilen in `VeranstaltungsDatenDrawer.tsx`/`event-detail.tsx`, die Kontaktzeile in
 * `customer-detail.tsx`) bauten bisher unabhaengig voneinander dieselbe simple
 * `[street, `${zip} ${city}`].filter(Boolean).join(", ")`-Verkettung — jetzt EINE Stelle, die
 * zusaetzlich Firma/Name/Zusatz/Land einbezieht und das Land als LESBAREN NAMEN zeigt (nicht als
 * rohen ISO-Code, s. `lib/laender.ts#landName`).
 *
 * Bewusst weiterhin eine EINZEILIGE Komma-Verkettung, kein DIN-5008-Mehrzeilen-Briefkopf — das
 * Konzept-Dokument (§ 2.4) haelt fest, dass die heutige Anzeige an allen bisherigen Stellen bewusst
 * schlicht ist; ein mehrzeiliges Adressblock-Layout waere ein eigenstaendiges Anzeige-Redesign,
 * nicht Teil dieses Auftrags.
 */
import { landName } from "./laender";

export interface AdresseAnzeigeWerte {
  company?: string | null;
  name?: string | null;
  street?: string | null;
  addition?: string | null;
  zip?: string | null;
  city?: string | null;
  countryCode?: string | null;
}

/**
 * `null`, wenn NICHTS gesetzt ist (Aufrufer entscheiden ueber den Leer-Fallback-Text, analog dem
 * bisherigen Verhalten von `lieferadresseStructured()`/der `address`-Variable in
 * `customer-detail.tsx`). Reihenfolge: Firma/Name (falls vorhanden, „Firma · Name" wenn beide
 * gesetzt sind) → Straße → Zusatz → PLZ Ort → Land.
 */
export function adresseEinzeilig(a: AdresseAnzeigeWerte): string | null {
  const firmaName = [a.company?.trim(), a.name?.trim()].filter(Boolean).join(" · ") || null;
  const zipCity = [a.zip?.trim(), a.city?.trim()].filter(Boolean).join(" ") || null;
  const teile = [firmaName, a.street?.trim() || null, a.addition?.trim() || null, zipCity, landName(a.countryCode)].filter(Boolean);
  return teile.length > 0 ? teile.join(", ") : null;
}
